import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import Questionnaire from "./Questionnaire/Questionnaire";
import DownloadAffiliate from "./DownloadAffiliate/DownloadAffiliate";
import Login from "./Login/Login";
import ForgotPassword from "./ForgotPassword/ForgotPassword";
import ForgotPasswordSuccess from "./ForgotPassword/ForgotPasswordSuccess";
import ResetPassword from "./ResetPassword/ResetPassword";
import UserRegister from "./UserRegister/UserRegister";
// import NotFound from "./NotFound";
import SelectSite from "./SelectSite/SelectSite";

/**
 * Main view when logged out. Here we take care of all routing login-related views.
 */
const Welcome = (props) => {
    return (
        <Switch>
            <Route path="/login/site/:hash?" exact component={SelectSite} />
            <Route path="/login/register/:url" exact component={UserRegister} />
            <Route path="/login/forgot-password" exact component={ForgotPassword} />
            <Route path="/login/forgot-password-success" exact component={ForgotPasswordSuccess} />
            <Route path="/login/reset-password/:hash" exact component={ResetPassword} />
            <Route path="/questionnaire/:hash" exact component={Questionnaire} />
            <Route path="/download/:hash" component={DownloadAffiliate} />
            <Route path="/login/:hash?" exact component={Login} />
            {/* <Route component={NotFound} /> */}
            <Route render={() => <Redirect to="/login" />} />
        </Switch>
    );
};

export default Welcome;
